// Single source of truth for the app version.
// Update this before every App Store / Play Store submission.
// Format: MAJOR.MINOR.PATCH — must match version in Xcode / build.gradle
export const APP_VERSION = "1.0.0";
